"use strict";
import debounce from 'lodash/debounce';
import Vue      from 'vue/dist/vue.common.js';

function minWidthValid(width, min=0) {
  return width >= min;
}

function maxWidthValid(width, max=false) {
  let valid = false;
  if (max) {
    valid = (width <= max);
  } else {
    valid = true;
  }
  return valid;
}

const ResponsiveContent = Vue.component('ts-responsive-content', {

  template: `
    <div v-if="active">
      <slot></slot>
    </div>
  `,

  data() {
    return {
      active: false
    };
  },

  props: {
    'maxWidth': {
      default: null,
      required: false,
      type: Number
    },
    'minWidth': {
      default: null,
      required: false,
      type: Number
    }
  },

  mounted() {
    window.addEventListener('resize', debounce(this.toggle, 300));
    this.toggle();
  },

  methods: {
    toggle(evt) {
      // const height = window.innerHeight;
      const width = window.innerWidth;

      if (minWidthValid(width, this.minWidth) &&
          maxWidthValid(width, this.maxWidth)
      ) {
        this.active = true;
      } else {
        this.active = false;
      }
    }
  }
});

export default ResponsiveContent;